import { Component, OnInit } from '@angular/core';
import { Yii } from "../../../../../libraries/interfaces/Yii";
import { IPopupMenuConfig } from "../../../../../libraries/component/popup-menu/popup-menu.component";
import { AuthService } from "../../../../../libraries/service/auth/auth.service";
import { TravellerDataTranslationService } from 'libraries/service/traveller-data-translation/traveller-data-translation.service';
import { PermissionResourceService } from 'libraries/service/resources/permission/permissionResource.service';
import { IAfidiumConnectConfig } from 'app/shared/model/afidium-connect.model';
import { wenji } from "libraries/interfaces/IWenji";
import { GlobalPermissions } from 'app/shared/enums/globalPermissions.enum';

enum Actions {
  logout = 'logout',
  profile = 'profile',
}
class Wording {
  public readonly hello: string = Yii.t('wui-app-js', 'Bonjour');
  public readonly logout: string = Yii.t('wui-app-js', 'Se déconnecter');
  public readonly profile: string = Yii.t('wui-app-js', 'Mon profil');
}

@Component({
  selector: 'app-header-user',
  templateUrl: 'app-header-user.component.html',
  styleUrls: ['app-header-user.component.scss']
})
export class AppHeaderUserComponent implements OnInit {
    public afidiumConnectConfig: IAfidiumConnectConfig = wenji?.connect;
    public readonly wording: Wording = new Wording();
    public popupMenuConfig: IPopupMenuConfig;
    public sayHello: string;

    constructor(
      public authService: AuthService, 
      private readonly travellerDataTranslationService: TravellerDataTranslationService,
      private readonly permissionResourceService: PermissionResourceService,
      ) { }

    public ngOnInit(): void {
      this.authService.loadUserInformations();
      this.initSayHello();
      this.initPopupMenuConfig();
    }

    public launchAction(action: Actions): void {
      switch(action) {
        case Actions.logout:
          if (this.afidiumConnectConfig?.bypass) {
            this.authService.logout(true)
          } else {
            this.authService.logoutAfidiumConnect();
          }
          break;
        case Actions.profile:
          this.authService.goToAfidiumConnectProfile();
          break;
        default:
          break;
      }
    }

    private initSayHello(): void {
      this.sayHello = `${this.wording.hello ?? ''} ${this.travellerDataTranslationService.getTravellerIdentity(this.authService.userContact)}`;
    }

    private initPopupMenuConfig(): void {
      this.permissionResourceService.hasPermission(GlobalPermissions.globalConnectLinkProfileShow).subscribe((showLinkProfile: boolean) => {
        this.popupMenuConfig = {
          buttonLabel: `<i class="icon fa fa-user fa-2x"></i>`,
          items: []
        };
        this.authService.initAfidiumConnect();
        if (this.authService.afidiumConnect.isOAuthResponseValid() && showLinkProfile) {
          this.popupMenuConfig.items.push({label: this.wording.profile, actionName: Actions.profile});
        }
        this.popupMenuConfig.items.push({label: this.wording.logout, actionName: Actions.logout});
      });

    }
}
